import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Spin, Empty } from "antd";

import "./PacientesPage.css";

const ACTION_CONFIG = {
  CREATE: { label: "Creación", color: "#15803d", bg: "#dcfce7" },
  UPDATE: { label: "Actualización", color: "var(--brand-primary)", bg: "#dbeafe" },
  DELETE: { label: "Eliminación", color: "#b91c1c", bg: "#fee2e2" },
};
const getActionConfig = (action) =>
  ACTION_CONFIG[action] || { label: action || "Cambio", color: "#595c5e", bg: "#f1f5f9" };

const fmtDatetime = (v) => {
  if (!v) return "—";
  const d = dayjs(v);
  return d.isValid() ? d.format("DD/MM/YYYY, HH:mm") : "—";
};

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Tab "Actividad" de un detalle. `fetcher` devuelve la promesa axios del
// endpoint /<modulo>/{id}/actividad; se monta solo cuando el tab esta activo,
// asi que siempre trae la bitacora fresca.
export default function ActividadTab({ fetcher, titulo = "Actividad" }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let vivo = true;
    setLoading(true);
    fetcher()
      .then((res) => vivo && setItems(Array.isArray(res.data) ? res.data : res.data?.items ?? []))
      .catch(() => vivo && setItems([]))
      .finally(() => vivo && setLoading(false));
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="cd-card">
      <div className="cd-card-header">
        <div className="cd-card-icon-wrap"><i className="fa-solid fa-clock" /></div>
        <h2 className="cd-card-title">
          {titulo}
          {items.length > 0 && <span className="cd-actividad-count">{items.length}</span>}
        </h2>
      </div>
      {loading ? (
        <div className="cd-loading-wrap"><Spin size="large" /></div>
      ) : items.length === 0 ? (
        <Empty description="Sin actividad registrada aún" style={{ margin: "40px 0" }} />
      ) : (
        <div className="cd-actividad-list">
          {items.map((it, idx) => {
            const cfg = getActionConfig(it.action);
            return (
              <div key={it.id_audit_log || idx} className="cd-actividad-item">
                <div className="cd-actividad-dot-col">
                  <div className="cd-actividad-dot" style={{ background: cfg.color }} />
                  {idx < items.length - 1 && <div className="cd-actividad-line" />}
                </div>
                <div className="cd-actividad-body">
                  <div className="cd-actividad-top-row">
                    <span className="cd-actividad-badge" style={{ color: cfg.color, background: cfg.bg }}>{cfg.label}</span>
                    <span className="cd-actividad-message">{it.message}</span>
                  </div>
                  <div className="cd-actividad-bottom-row">
                    <span className="cd-actividad-time">{fmtDatetime(it.datetime)}</span>
                    {it.user_name && (
                      <div className="cd-actividad-user">
                        <span>{capitalize(it.user_name)}</span>
                        {it.user_email && <span className="cd-actividad-email">{it.user_email}</span>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
